import { ReportFormData } from "../types/ReportFormData";
import { ReportTemplate } from "../types/ReportTemplate";
import {
	getAllTemplates as apiGetAllTemplates,
	getTemplate as apiGetTemplate,
	createTemplate as apiCreateTemplate,
	updateTemplate as apiUpdateTemplate,
	deleteTemplate as apiDeleteTemplate,
} from "../services/templateService";

/**
 * Load all templates from API
 */
export const getAllTemplates = async (): Promise<ReportTemplate[]> => {
	try {
		return await apiGetAllTemplates();
	} catch (error) {
		console.error("Error loading templates:", error);
		throw error;
	}
};

/**
 * Save a new template via API
 */
export const saveTemplate = async (
	name: string,
	formData: ReportFormData
): Promise<ReportTemplate> => {
	try {
		return await apiCreateTemplate(name, formData);
	} catch (error: any) {
		console.error("Error saving template:", error);
		// Re-throw with user-friendly message if available
		if (error.response?.data?.detail) {
			throw new Error(error.response.data.detail);
		}
		throw error;
	}
};

/**
 * Update an existing template via API
 */
export const updateTemplate = async (
	id: string,
	updates: Partial<ReportTemplate>
): Promise<ReportTemplate> => {
	try {
		return await apiUpdateTemplate(id, updates);
	} catch (error: any) {
		console.error("Error updating template:", error);
		// Re-throw with user-friendly message if available
		if (error.response?.data?.detail) {
			throw new Error(error.response.data.detail);
		}
		throw error;
	}
};

/**
 * Delete a template via API
 */
export const deleteTemplate = async (id: string): Promise<void> => {
	try {
		await apiDeleteTemplate(id);
	} catch (error: any) {
		console.error("Error deleting template:", error);
		// Re-throw with user-friendly message if available
		if (error.response?.data?.detail) {
			throw new Error(error.response.data.detail);
		}
		throw error;
	}
};

/**
 * Load a specific template by ID
 */
export const loadTemplate = async (id: string): Promise<ReportTemplate | null> => {
	try {
		return await apiGetTemplate(id);
	} catch (error: any) {
		if (error.response?.status === 404) {
			return null;
		}
		console.error("Error loading template:", error);
		throw error;
	}
};
